import { createAction } from '@reduxjs/toolkit';

export const fetchReportsInit = createAction('[Reports] Fetch Reports Init');
export const fetchReportsSuccess = createAction(
  '[Reports] Fetch Reports Success'
);
export const fetchReportsFail = createAction('[Reports] Fetch Reports Fail');

export const clearReportsData = createAction('[Reports] Clear Reports Data');
